<template>
  <div>
    <el-dialog width="500px" :before-close="handleClose" :visible.sync="mydialogFormVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{title}}</div>
      </div>
      <el-form :model="myform" ref="myform" label-width="120px" :validate-on-rule-change="false" :rules="rules">
        <el-form-item :label="label[0] + ':'"   prop="one">
          <el-input v-model="myform.one" placeholder="必填，2-40个字"></el-input>
        </el-form-item>
        <el-form-item :label="label[1] + ':'"   prop="two">
          <el-input-number v-model="myform.two" :step="1" :min="0" :max="100" label="描述文字"></el-input-number>
          <!-- <div style="color: rgb(215, 76, 76);font-size: 10px;">Tip:请输入分数</div>       -->
        </el-form-item>
        <el-form-item :label="label[2] + ':'"   prop="three">
          <el-radio v-model="myform.three" :label="1">启用</el-radio>
          <el-radio v-model="myform.three" :label="0">停用</el-radio>      
        </el-form-item>
        <el-form-item :label="label[3] + ':'"   prop="four">
          <el-radio v-model="myform.four" :label="1">是</el-radio>
          <el-radio v-model="myform.four" :label="0">否</el-radio>      
        </el-form-item>
        <el-form-item :label="label[4] + ':'"   prop="five">
          <el-radio v-model="myform.five" :label="1">是</el-radio>
          <el-radio v-model="myform.five" :label="0">否</el-radio>      
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quit">取 消</el-button>
        <el-button v-if="!isClick" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="submit('myform')">提 交</el-button>
        <el-button v-else type="primary" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" disabled>提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {
  list
} from "@/api/labelClass";
export default {
    props:{
        title:{
            type:String,
            default:'编辑'
        },
        myform:Object,
        // rules:Object,
        dialogFormVisible:Boolean,
        label:Array
    },
    watch:{
      dialogFormVisible:{
       deep: true,
       handler(v) {
          this.mydialogFormVisible = v
       }
      }
    },
    data(){
        return {
          isClick:false,
          classList:[],

          mydialogFormVisible:this.dialogFormVisible,
          rules: {
            one: [
              { required: true, message: '请输入内容', trigger: 'change' },
              { min: 2, max: 40, message: '长度在 2 到 40 个字符', trigger: 'blur' }
            ],
            two: [
              { required: true, message: '请填写分数', trigger: 'change' },
            ],
            three: [
              { required: true, message: '请选择状态', trigger: 'change' },
            ],
            four: [
              { required: true, message: '请选择是否为图片基础评级', trigger: 'change' },
            ],
            five: [
              { required: true, message: '请选择是否为视频基础评级', trigger: 'change' },
            ],
          }
        }
    },
    methods:{
        ...mapActions(["setDialogFormVisible"]),
        handleClose(){
          this.$refs['myform'].clearValidate();
          this.mydialogFormVisible = false
          this.$emit('changedialogFormVisible',this.mydialogFormVisible)
          this.setDialogFormVisible(false)
        },
        quit(){
          this.$refs['myform'].clearValidate();
          this.mydialogFormVisible = false
          this.$emit('changedialogFormVisible',this.mydialogFormVisible)
          this.setDialogFormVisible(false)

        },
        submit(myform){
          this.$refs[myform].validate((valid) => {
            if (valid) {
              this.$confirm('是否确定提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
              }).then(() => {
                this.isClick = true
                setTimeout(() => {
                  this.isClick = false
                }, 2000);
                
                this.$emit('dialogSubmit',this.myform)
                this.mydialogFormVisible = false
                this.$emit('changedialogFormVisible',this.mydialogFormVisible)
                this.setDialogFormVisible(false)
                this.$refs.myform.resetFields();
              }).catch(() => {
                // this.$message({
                //   type: 'info',
                //   message: '已取消'
                // });          
              });
            } else {
              this.$message({
                  type: 'info',
                  message: '请正确填写！'
                });   
              return false;
            }
          });
          
          
        },
        changeX(e){
          // console.log(e)
          this.$forceUpdate()
        },

        //获取分类列表
      async getListAsync () {
        let { status, data, message, errors } = await list({pageSize:200});
        if (status) {
          data.forEach(e => {
            this.classList.push({
              value:e.name,
              label:e.name
            })
          })
        } else {
          let errortext = ''
          for (const key in errors) {
            errortext += errors[key]
          }
          this.$message.error({ message: message + errortext });
        }
      }
    },
    created(){
      // this.getListAsync()
    },
    mounted(){
      
    }
}
</script>
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
::v-deep .el-form-item__label{
  font-weight: 600;
}

</style>